( function( $ ) {
	'use strict';

	$( function() {
		// Scroll to items when after facet filter/pagination change
		$( document ).on('facetwp-loaded', function() {
			if ( FWP.loaded ) {
				const headerHeight = $( '.js-sticky-header' ).height();

				$( 'html, body' ).animate({
					scrollTop: $( '.facetwp-template' ).offset().top - headerHeight - 100
				}, 500);
			}
		});
	} );
} )( jQuery );
